<div class="student-stories">
  <div class="pre-page spen-mod-heading lv-1">
    <h1 class="heading-text">
      <button class="spen-mod-btn is-primary" (click)="slideMenu()"><i class="fa fa-reorder"></i></button>ストーリー
    </h1>
  </div>

  <app-tab-view [tabOptions]="tabOptions"></app-tab-view>
  @switch (currentTab) {
    @case ('grade_1') {
      <app-story-detail [grade]="'1'"></app-story-detail>
    }
    @case ('grade_2') {
      <app-story-detail [grade]="'2'"></app-story-detail>
    }
    @case ('grade_3') {
      <app-story-detail [grade]="'3'"></app-story-detail>
    }
    @case ('summary') {
      <app-story-detail></app-story-detail>
    }
  }
</div>
